export enum StoryLoadTypeEnum {
  AllAtOnce = 'All-At-Once',    // Load everything in one load chunk
  Progressive = 'Progressive',  // Load shown object assets (static, dynamic) for each chapter in sequential load chunks AND a catch-all load chunk
  OnDemand = 'On-Demand'        // Load shown object assets (static, dynamic) for each chapter in sequential load chunks
}
